import { display, fontSize, fontWeight, height, maxWidth } from "@mui/system";

import { fonts, gutterX, radius } from "../shared/ticketLayout";

const styles = (theme) => ({
  containerPaper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: radius.panel,
    overflow: "hidden",
    // O container é flex column com altura limitada. Sem isto o cartão herda
    // flex-shrink: 1 e é comprimido, e o overflow: hidden acima transforma a
    // compressão em corte — o fim do cartão (a descrição) some.
    flexShrink: 0,
    backgroundColor: theme.palette.background.wallpaper,
  },
  // --- Cabeçalho do cartão de OS ---
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    px: { xs: 1.5, sm: 2 },
    py: 1.25,
    minWidth: 0,
  },
  cardHeaderIdentificacao: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    flexWrap: "wrap",
    minWidth: 0,
  },
  cardNumeroOs: {
    fontSize: fonts.sectionTitle,
    fontWeight: 700,
    letterSpacing: "-0.01em",
  },
  cardMenuButton: {
    flexShrink: 0,
  },
  // --- Seções internas do cartão ---
  cardSecao: {
    px: { xs: 1.5, sm: 2 },
    py: 1.5,
  },
  cardSecaoHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    mb: 0.5,
  },
  cardSecaoTitulo: {
    fontSize: fonts.chip,
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  textoVazio: {
    fontSize: fonts.body,
    fontStyle: "italic",
    color: theme.palette.text.disabled,
    p: 1,
  },
  containerTecnicos: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    mt: 0.5,
  },
  avatarTecnico: {
    width: 32,
    height: 32,
  },
  nomeTecnico: {
    fontSize: fonts.body,
  },
  nameUser: {
    fontSize: fonts.body,
    fontWeight: 600,
    lineHeight: 1.4,
  },
  containerHeader: {
    display: "flex",
    flexDirection: "column",
    padding: 2,
    gap: 1,
  },
  paperAnexo: {
    flexShrink: 0,
    width: 80,
    height: 80,
    overflow: "hidden",
    borderRadius: 1,
    cursor: "pointer",
  },
  containerActions: {
    display: "flex",
    flexDirection: { xs: "column-reverse", sm: "row" },
    justifyContent: "flex-end",
    marginTop: 2,
    px: gutterX,
    gap: 1.5,
  },
  containerPaperModal: {
    width: "100%",
    borderRadius: radius.panel,
    padding: { xs: 1, sm: 2 },
    overflowY: "auto",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1,
    flexWrap: "wrap",
  },
  boxBodyModal: { px: gutterX },
  containerBodyModal: {
    // O container do modal é flex column; flex:1 + minHeight:0 fazem este
    // bloco ocupar a altura restante e rolar por conta própria. O maxHeight
    // de 85% anterior dependia de o pai ter altura definida em pixel.
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    display: "flex",
    gap: 1,
    flexDirection: "column",
    p: 1,
  },
  dataHistorico: {
    fontSize: fonts.label,
    color: theme.palette.text.secondary,
  },
  titleDescription: {
    fontSize: fonts.sectionTitle,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  containerComponent: {
    position: "absolute",
    borderRadius: radius.panel,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "96%", sm: "92%", md: "90%" },
    maxWidth: "1000px",
    height: { xs: "92vh", sm: "700px" },
    maxHeight: "92vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxShadow: 24,
    bgcolor: "background.paper",
  },
  // Subtítulo com o protocolo do atendimento de origem. Estava escrito inline
  // sobrescrevendo o titleDescription, o que deixava as duas linhas do
  // cabeçalho com regras concorrentes.
  subtituloProtocolo: {
    fontSize: fonts.label,
    fontWeight: 500,
    opacity: 0.7,
    display: "flex",
    alignItems: "center",
    gap: 0.75,
  },
  botaoFechar: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  containerEditOs: {
    px: gutterX,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "80px",
    justifyContent: "center",
  },
  containerInfoOs: {
    // relative para que o botão de fechar se ancore neste bloco, e não no
    // container do modal.
    position: "relative",
    px: gutterX,
    py: 1.5,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minHeight: "80px",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  containerOS: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    overflow: "auto",
    p: { xs: 1, sm: 2 },
  },

  boxEdit: {
    width: "100%",
    display: "flex",
    alignItems: "center",

    justifyContent: "space-between",
  },
  containerPaperMensagem: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  containerAvatar: {
    width: "100%",
    display: "flex",
    gap: 2,
  },
  nameUserViewed: {
    fontSize: fonts.body,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px",
  },
  textMensagem: {
    fontSize: fonts.reading,
    lineHeight: 1.6,
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  boxHistorico: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "85%",
    overflow: "auto",
    p: 1,
  },
  paperHistorico: {
    p: { xs: 1.25, sm: 2 },
    mx: gutterX,
    borderRadius: radius.panel,
  },
  containerHistorico: {
    p: 2,
    display: "flex",
    gap: 1,
  },
  bodyMensagem: { padding: 2, display: "flex", gap: 2, alignItems: "center" },
  containerData: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  containerDataTenico: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    padding: 2,
  },
  titleData: { fontWeight: 600, fontSize: fonts.label },
  boxData: { display: "flex", flexDirection: "column", padding: 2 },
  boxHeader: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
  },
  boxDataTecnico: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    padding: 0.5,
  },
  containerAnexos: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    py: 1,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  boxImg: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    display: "block",
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
  },
  boxWithoutImg: {
    width: "40px",
    height: "40px",

    display: "block",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.lighter,
  },
  chip: {
    fontWeight: 600,
    color: theme.palette.white.main,
    fontSize: fonts.chip,
    textTransform: "capitalize",
    maxWidth: "100%",
    height: "22px",
    borderRadius: radius.chip,
  },
});

export default styles;
